// Constantes utilizadas no módulo Dashboard

// Chaves do localStorage (compartilhadas com outros módulos)
export const STORAGE_KEYS = {
  TOKEN: "token",
  USER: "user",
  REGION: "region",
  NAME_USER: "nameUser",
  ALL_PLOTS: "allPlots",
  UNIQUE_OCCURRENCES: "uniqueOccurrences",
  OCCURRENCES_SORT: "occurrences-sort",
  REGISTER_PLOT_ALTERNATE: "register-plot-alternate",
  REGISTERS_TO_INVITE: "registers-to-invite"
};

export const PLAGUE_NAMES = [
  { name: "Lagarta Verde", scientific: "Psorocampa Denticulata" },
  { name: "Lagarta Parda", scientific: "Thyrinteina Arnobia" },
  { name: "Lagarta Cachorrinho", scientific: "Eupseudosoma Spp" },
  { name: "Glena", scientific: "Glena Bipennaria" },
  { name: "Lagarta Marrom", scientific: "Oxydia Vesulia" },
  { name: "Sarsina", scientific: "Sarsina Spp" },
  { name: "Dyrphia", scientific: "Dyrphia Rosacordis" },
  { name: "Nistalea", scientific: "Nystalea Nyseus" },
  { name: "Hylesia", scientific: "Hylesia Sp" },
  { name: "Sabulodes", scientific: "Sabulodes Caberata" },
  { name: "Psilideo de Concha", scientific: "Glycaspis Brimblecombei" },
  { name: "Percevejo Bronzeado", scientific: "Thaumastocoris Peregrinus" },
  { name: "Besouro Amarelo", scientific: "Costalimaita Ferruginea" },
  { name: "Besouro Azul", scientific: "Sternocolaspis Quatuord" },
];

// Mapeamento de nomes científicos para nomes de pragas
export const PLAGUE_MAP = {
  "Thyrinteina Arnobia": "Lagarta Parda",
  "Psorocampa Denticulata": "Lagarta Verde",
  "Eupseudosoma Spp": "Lagarta Cachorrinho",
  "Oxydia Vesulia": "Lagarta Marrom",
  "Glena Bipennaria": "Glena",
  "Sarsina Spp": "Sarsina",
  "Dyrphia Rosacordis": "Dyrphia",
  "Nystalea Nyseus": "Nistalea",
  "Hylesia Sp": "Hylesia",
  "Sabulodes Caberata": "Sabulodes",
  "Glycaspis Brimblecombei": "Psilideo de Concha",
  "Thaumastocoris Peregrinus": "Percevejo Bronzeado",
  "Costalimaita Ferruginea": "Besouro Amarelo",
  "Sternocolaspis Quatuord": "Besouro Azul"
};

// Níveis de infestação
export const INFESTATION_LEVELS = {
  LOW: { min: 15, max: 30, label: "Baixo", color: "green" },
  MEDIUM: { min: 30.1, max: 50.0, label: "Médio", color: "#FEC601" },
  HIGH: { min: 50.1, max: 100, label: "Alta", color: "red" }
};

// Mensagens
export const MESSAGES = {
  LOADING_ERROR: "Não foi possível carregar as informações corretamente, realize o login novamente!",
  REGISTERS_SUCCESS: "Registro cadastrados offline concluídos com sucesso!",
  REGISTERS_ERROR: "Erro ao realizar o registro, verifique as informações novamente",
  NO_RESULTS: "Nenhum resultado encontrado!"
};

// Meses do ano
export const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

